import React from "react";
import { SEO, MainLayout, RouteStopOne } from "../../../../components";

const RoutesStepsPage = () => {
  return (
    <>
      <SEO title="routes steps" />
      <MainLayout>
        <RouteStopOne />
      </MainLayout>
    </>
  );
};

export default RoutesStepsPage;
